import Logger from './logger.js';

const defaultOptions = {
    debug: false,
    delay: 500,
    onError: () => { },
};
/**
 * Client side tasks queue
 * @class
 * @example
 * ```ts
 * const queue = new Queue()
 * queue.push(() => {})
 * ```
 */
class Queue {
    tasks;
    options;
    running = false;
    logger;
    /**
     * @param options Options
     */
    constructor(options) {
        this.options = { ...defaultOptions, ...options };
        this.tasks = [];
        this.logger = new Logger("queue");
        this.log(`Starting process tasks after ${this.options.delay}ms`);
        this.run();
    }
    /**
     * Add task in queue
     * @param task Task function
     */
    push(task) {
        this.pushTask(task);
    }
    log(message, meta) {
        if (!this.options.debug)
            return;
        this.logger.debug(message, meta);
    }
    pushTask(task) {
        this.tasks.push(task);
        this.log("Task registered. Waiting for CPU is idle", task);
        if (this.running) {
            this.requestPopInIdle();
        }
    }
    execute = async () => {
        const task = this.tasks.shift();
        if (!task) {
            this.log("Queue is empty. Waiting for a new task");
            return;
        }
        try {
            this.log("Task found. Run executor", task);
            await task();
            // this.log('Run executor successful')
        }
        catch (error) {
            this.log("Run executor failed", error);
            if (this.options.onError) {
                // @ts-ignore
                this.options.onError(error, task);
            }
        }
    };
    requestPopInIdle() {
        (window.requestIdleCallback || window.setTimeout)(this.execute);
    }
    run() {
        if (typeof window !== "undefined") {
            const performance = window.performance.getEntriesByType("navigation")[0];
            if (performance && performance.loadEventEnd > 0) {
                this.runTasksExecutor();
            }
            else {
                window.addEventListener("load", () => setTimeout(this.runTasksExecutor.bind(this), this.options.delay));
            }
        }
    }
    runTasksExecutor() {
        this.tasks.forEach(() => this.requestPopInIdle());
        this.running = true;
    }
}

export { Queue as default };
//# sourceMappingURL=queue.js.map
